import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11","key":"svg-0"}]]

const IconLetterU = createReactComponent('outline', 'letter-u', 'LetterU', __iconNode);

export default IconLetterU;